import { Loading, RemoteData } from '@ftr/foundation'
import { catchError, from, map, Observable, of, shareReplay, startWith, switchMap } from 'rxjs'

export function performTsRestApiRequest<T, U, C>(
  apiClient: Observable<C>,
  {
    requestFn,
    responseMapFn,
    responseErrorMapFn = result => RemoteData.failure(result),
  }: {
    requestFn: (client: C) => Promise<T>
    responseMapFn: (result: T) => RemoteData<U>
    responseErrorMapFn?: (result: Error) => RemoteData<U, Error>
  },
): Observable<Loading | RemoteData<U, Error>> {
  return apiClient.pipe(
    switchMap(client => {
      return from(requestFn(client)).pipe(
        map(result => responseMapFn(result)),
        catchError(e => {
          if (e?.name === 'ZodError') {
            const issues: { received?: string }[] | undefined = e?.issues
            return of(responseErrorMapFn(new Error(issues?.map(issue => issue?.received).join(', '))))
          }

          return of(responseErrorMapFn(new Error('An unknown error occurred')))
        }),
      )
    }),
    startWith(RemoteData.loading()),
    shareReplay(1),
  )
}
